/**
 * Normalizes a string for comparison by trimming whitespace and converting to lowercase
 * @param value - The string to normalize
 * @returns Normalized string (trimmed and lowercase)
 */
export const normalizeForComparison = (value: string): string => {
  return value.trim().toLowerCase();
};
